import React from "react";
import styled from "styled-components";
import { get } from "lodash";
import PrismicRichText from "../components/PrismicRichText";
import * as colors from "../constants/colors";

const StlRoot = styled.section`
  padding: 28px 20px 48px;
  margin: 20px 0px 40px;
  color: ${colors.textDark};
  p:has(strong) {
    margin: 20px 0;
  }

  @media (min-width: 900px) {
    padding: 56px;
    margin: 20px 0px 60px;
  }
`;

const StlInner = styled.div`
  max-width: 900px;
  margin: 0 auto;
`;

const StlContent = styled.div`
  width: 100%;
  p {
    margin-top: 2rem;
  }
`;

const TextSlice = (slice) => {
  const content = get(slice, "primary.content");

  if (!Array.isArray(content) || !content.length) {
    return null;
  }

  return (
    <StlRoot>
      <StlInner>
        <StlContent>
          <PrismicRichText render={content} />
        </StlContent>
      </StlInner>
    </StlRoot>
  );
};

export default TextSlice;
